module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/CPU#1-67d3ea5b6243e5ce40ef46a569bfb0ee.svg";